import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding-bottom: 20px;
  width: 100%;
`;
